import type { ComposerTranslation } from 'vue-i18n';

export const t: ComposerTranslation = (...attrs) => (window as any).i18n.t(...attrs);

export function getLocaleFromCountryCode(
  countryCode: 'en' | 'da' | 'sv' | 'no' | 'fr' | 'es' | string
) {
  if (countryCode === 'en') {
    return 'en-US';
  }
  if (countryCode === 'da') {
    return 'da-DK';
  }
  if (countryCode === 'sv') {
    return 'sv-SE';
  }
  if (countryCode === 'no') {
    return 'no-NO';
  }
  if (countryCode === 'fr') {
    return 'fr-FR';
  }
  if (countryCode === 'es') {
    return 'es-ES';
  }

  return 'en-US';
}
